import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Result } from 'app/core/models/result';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ModuleService } from 'app/module/services/module.service';

@Component({
    selector: 'app-add-module',
    templateUrl: './add-module.component.html',
    styleUrls: ['./add-module.component.css']
})
export class AddModuleComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    submitAttempt: boolean = false;
    addModuleFormGroup: FormGroup;

    constructor(
        private moduleService: ModuleService,
        private fb: FormBuilder,
		private location: Location,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.headerTitle = {
            title: 'Add Module', breadcrumbs: [
                { title: 'Modules', url: ['/module'] }
            ]
        }
        this.initializeForm();
    }

    initializeForm(): void {
        this.addModuleFormGroup = this.fb.group(
            {
                name: ['', Validators.required],
                isActive: [true, Validators.required]
            }
        );
    }

    addModule(): void {
        this.submitAttempt = true;
        if (this.addModuleFormGroup.valid) {
            const formValue = this.addModuleFormGroup.value;
            this.moduleService.create(formValue).subscribe(
                moduleId => {
                    this.router.navigate(['./module']);
                },
                error => {
                    this.errors = (<Result>error).errorList;
                });
        }
    }

    onBack(): void {
        this.location.back();
    }
}
